import React from 'react';
import { useAppSelector } from '../../store/hooks/hooks';
import { TRAININGS_COLUMNS } from '../../common/initialValues/initialValues';
import { useGlobalFilter, usePagination, useSortBy, useTable } from 'react-table';
import arrowDown from '../../assets/icons/arrow-down-orange-icon.svg';
import emptyTableIcon from '../../assets/icons/empty-state-illustration.svg';
import { GlobalFilter } from '../dashboard/GlobalFilter';
import { useNavigate } from 'react-router-dom';

export const TrainingTable = () => {
  const reachedTrainings = useAppSelector((state) => state.trainings.reachedTrainings);

  const columns = React.useMemo(() => TRAININGS_COLUMNS, []);
  const data = React.useMemo(() => reachedTrainings, [reachedTrainings]);

  const navigate = useNavigate();

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    prepareRow,
    canNextPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    state,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
      // initialState: { pageIndex: 0 },
      initialState: { pageSize: 50 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const { pageIndex, pageSize, globalFilter } = state;

  return (
    <div className='relative font-h5-regular'>
      <div className='filters'>
        <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
      </div>
      {page.length ? (
        <>
          <table className='font-h5-regular simply-table' {...getTableProps}>
            <thead className='simply-table__head'>
              {headerGroups.map((headerGroup) => (
                <tr className='simply-table__head__row' {...headerGroup.getFooterGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th
                      className={`${column.isSorted && 'primary-200'} simply-table__head__row__th font-h5-regular`}
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                    >
                      <span>{column.render('Header')}</span>

                      {column.isSorted ? <img src={arrowDown} alt='' className={`${column.isSortedDesc && 'rotate-180'}`} /> : ''}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody className='simply-table__body' {...getTableBodyProps}>
              {page.map((row) => {
                prepareRow(row);
                return (
                  <tr onClick={() => navigate('trainDocument')} className='simply-table__body__row pointer' {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      if (cell.column.Header === '') {
                        if (cell.value) {
                          return (
                            <td className='simply-table__body__column' {...cell.getCellProps()}>
                              <img width={'50px'} src={cell.value} alt='' />
                            </td>
                          );
                        } else {
                          return <td className='simply-table__body__column' {...cell.getCellProps()}></td>;
                        }
                      } else
                        return (
                          <td className='simply-table__body__column' {...cell.getCellProps()}>
                            {cell.render('Cell')}
                          </td>
                        );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
          <div className='text-center'>
            <span>
              Page{' '}
              <strong>
                {pageIndex + 1} of {pageOptions.length}
              </strong>{' '}
            </span>
            <span>
              Go to page:{' '}
              <input
                type='number'
                defaultValue={pageIndex + 1}
                onChange={(e) => {
                  const pageNumber = e.target.value ? Number(e.target.value) - 1 : 0;
                  gotoPage(pageNumber);
                }}
                style={{ width: '50px' }}
              />
            </span>
            <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
              {'<<'}
            </button>
            <button onClick={() => previousPage()} disabled={!canPreviousPage}>
              Previous
            </button>
            <button onClick={() => nextPage()} disabled={!canNextPage}>
              Next
            </button>
            <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
              {'>>'}
            </button>
            <select value={pageSize} onChange={(e) => setPageSize(Number(e.target.value))}>
              {[10, 100, 500].map((pageSize) => (
                <option key={pageSize} value={pageSize}>
                  Show {pageSize}
                </option>
              ))}
            </select>
          </div>
        </>
      ) : (
        <>
          <div className='text-center padding-top-4'>
            <picture className='height-60'>
              <img className='height-60' src={emptyTableIcon} alt='' />
            </picture>
            <h3 className='font-h3-regular margin-top-1'>Nothing here yet</h3>
          </div>
        </>
      )}
    </div>
  );
};
